<template>
  <el-dialog title="批量转采购订单" :close-on-click-modal="false" :visible.sync="visible" width="94%" append-to-body>
    <el-form ref="dataForm" :model="dataForm" :rules="dataRule" label-width="90px">
      <el-row>
        <el-col :span="12">
          <el-form-item label="请购单">
            <span>{{ requisitionSummary }}</span>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="订购日期" prop="orderDate">
            <el-date-picker v-model="dataForm.orderDate" type="date" value-format="yyyy-MM-dd" style="width:100%" />
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="预计生成">
            <span>{{ poPreviewText }}</span>
          </el-form-item>
        </el-col>
      </el-row>
      <el-form-item label="备注">
        <el-input v-model="dataForm.remark" placeholder="将写入各张采购订单备注" />
      </el-form-item>

      <el-table border v-loading="linesLoading" :data="displayLines" :header-cell-style="{ background: '#f5f7fa', color: '#606266', textAlign: 'center' }">
        <el-table-column type="index" label="序号" width="60" header-align="center" align="center" />
        <el-table-column prop="materialCode" label="产品编码" min-width="120" header-align="center" align="left" />
        <el-table-column prop="materialName" label="产品名称" min-width="130" header-align="center" align="left" />
        <el-table-column prop="specs" label="规格" min-width="90" header-align="center" align="left" />
        <el-table-column prop="sourceSummary" label="来源请购" min-width="140" header-align="center" align="left" show-overflow-tooltip />
        <el-table-column label="供应商" min-width="180" header-align="center" align="left">
          <template slot-scope="scope">
            <el-select
              v-model="scope.row.supplierId"
              placeholder="选择供应商"
              filterable
              style="width:100%"
              @change="val => onSupplierChange(scope.row, val)"
            >
              <el-option
                v-for="item in allSuppliers"
                :key="item.supplierId"
                :label="item.supplierName"
                :value="item.supplierId"
              />
            </el-select>
          </template>
        </el-table-column>
        <el-table-column prop="quantity" label="订购数量" width="110" header-align="center" align="left" />
        <el-table-column prop="price" label="含税单价" width="170" header-align="center" align="left">
          <template slot-scope="scope">
            <el-input-number v-model="scope.row.price" :min="0" :precision="2" style="width:100%" @change="calcLineAmount(scope.row)" />
          </template>
        </el-table-column>
        <el-table-column prop="tax" label="税点" width="120" header-align="center" align="left">
          <template slot-scope="scope">
            <el-select v-model="scope.row.tax" placeholder="税点" style="width:100%">
              <el-option v-for="item in taxList" :key="item.dictValue" :label="item.dictLabel" :value="Number(item.dictValue)" />
            </el-select>
          </template>
        </el-table-column>
        <el-table-column prop="deliveryDate" label="交货日期" width="150" header-align="center" align="left">
          <template slot-scope="scope">
            <el-date-picker v-model="scope.row.deliveryDate" type="date" value-format="yyyy-MM-dd" style="width:100%" />
          </template>
        </el-table-column>
        <el-table-column prop="amount" label="行金额" width="100" header-align="center" align="left" />
        <el-table-column label="操作" width="70" header-align="center" align="center">
          <template slot-scope="scope">
            <el-button type="text" size="small" @click="removeDisplayLine(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-form>

    <span slot="footer" class="dialog-footer">
      <el-button @click="visible = false">取消</el-button>
      <el-button type="primary" :disabled="submitLoading || !displayLines.length" @click="submitHandle">生成采购订单</el-button>
    </span>
  </el-dialog>
</template>

<script>
import request from '../../api/request'

function today() {
  const d = new Date()
  const p = n => String(n).padStart(2, '0')
  return d.getFullYear() + '-' + p(d.getMonth() + 1) + '-' + p(d.getDate())
}

export default {
  data() {
    return {
      visible: false,
      submitLoading: false,
      linesLoading: false,
      requisitionIds: [],
      requisitionCodes: [],
      sourceLines: [],
      displayLines: [],
      lineInputCache: {},
      allSuppliers: [],
      taxList: [],
      dataForm: { orderDate: '', remark: '' },
      dataRule: {
        orderDate: [{ required: true, message: '订购日期不能为空', trigger: 'change' }]
      }
    }
  },
  computed: {
    requisitionSummary() {
      const codes = this.requisitionCodes || []
      if (!codes.length) return ''
      if (codes.length === 1) return codes[0]
      return `${codes[0]} 等${codes.length}单`
    },
    poPreviewCount() {
      return new Set((this.displayLines || []).map(l => l.supplierId).filter(Boolean)).size
    },
    poPreviewText() {
      const n = this.poPreviewCount
      if (!this.displayLines.length) return '0 张采购订单'
      if (!n) return '请先为明细选择供应商'
      return `${n} 张采购订单（按供应商拆分）`
    }
  },
  methods: {
    init(rows) {
      const list = rows || []
      this.requisitionIds = list.map(r => r.requisitionId).filter(Boolean)
      this.requisitionCodes = list.map(r => r.requisitionCode).filter(Boolean)
      this.visible = true
      this.submitLoading = false
      this.sourceLines = []
      this.displayLines = []
      this.lineInputCache = {}
      this.allSuppliers = []
      this.dataForm = { orderDate: today(), remark: '' }
      if (!this.requisitionIds.length) {
        this.$message.warning('请至少选择一张请购单')
        this.visible = false
        return
      }
      this.loadTaxList().then(() => this.loadLines())
    },
    loadTaxList() {
      return request.get('/sys/dicts', { params: { dictType: 'TAX' } }).then(res => {
        this.taxList = res.data || []
      }).catch(() => { this.taxList = [] })
    },
    loadLines() {
      this.linesLoading = true
      request.post('/purchase/purchaseRequisition/linesForBatchConvert', this.requisitionIds).then(res => {
        const data = res.data || {}
        const lines = data.list || []
        if (!lines.length) {
          this.$message.warning('所选请购单没有可转采购的明细')
          this.displayLines = []
          return
        }
        this.sourceLines = lines.map(line => ({
          ...line,
          remainQuantity: Number(line.remainQuantity),
          supplierId: line.defaultSupplierId || '',
          supplierName: line.defaultSupplierName || ''
        }))
        this.allSuppliers = (data.allSuppliers || []).map(item => ({
          supplierId: item.supplierId,
          supplierName: item.supplierName
        }))
        lines.forEach(line => {
          if (!line.defaultSupplierId) return
          if (this.allSuppliers.some(s => s.supplierId === line.defaultSupplierId)) return
          this.allSuppliers.push({
            supplierId: line.defaultSupplierId,
            supplierName: line.defaultSupplierName || line.defaultSupplierId
          })
        })
        this.rebuildDisplayLines()
      }).catch(() => {}).finally(() => { this.linesLoading = false })
    },
    resolveSupplierName(supplierId) {
      const item = (this.allSuppliers || []).find(s => s.supplierId === supplierId)
      return item ? item.supplierName : ''
    },
    cacheDisplayInputs() {
      const cache = {}
      ;(this.displayLines || []).forEach(row => {
        cache[this.buildRowKey(row.materialId, row.supplierId)] = {
          price: row.price,
          tax: row.tax,
          deliveryDate: row.deliveryDate
        }
      })
      this.lineInputCache = cache
    },
    buildRowKey(materialId, supplierId) {
      return `${materialId}_${supplierId || ''}`
    },
    rebuildDisplayLines() {
      this.cacheDisplayInputs()
      const map = new Map()
      this.sourceLines.forEach(src => {
        const supplierId = src.supplierId || ''
        const key = this.buildRowKey(src.materialId, supplierId)
        if (!map.has(key)) {
          const cached = this.lineInputCache[key] || {}
          const defaultPrice = src.defaultPrice != null ? Number(src.defaultPrice) : null
          const row = {
            rowKey: key,
            materialId: src.materialId,
            materialCode: src.materialCode,
            materialName: src.materialName,
            specs: src.specs,
            supplierId,
            supplierName: src.supplierName || '',
            quantity: 0,
            price: cached.price != null ? cached.price : defaultPrice,
            tax: cached.tax != null ? cached.tax : (src.defaultTax != null ? Number(src.defaultTax) : null),
            deliveryDate: cached.deliveryDate || '',
            amount: 0,
            sourceSummary: '',
            allocs: []
          }
          map.set(key, row)
        }
        const row = map.get(key)
        const qty = Number(src.remainQuantity || 0)
        row.quantity = Number((row.quantity + qty).toFixed(2))
        row.allocs.push({
          requisitionLineId: src.requisitionLineId,
          quantity: qty,
          requisitionCode: src.requisitionCode
        })
        const dates = row.allocs
          .map(a => {
            const srcLine = this.sourceLines.find(s => s.requisitionLineId === a.requisitionLineId)
            return srcLine && srcLine.requiredDate ? String(srcLine.requiredDate).slice(0, 10) : ''
          })
          .filter(Boolean)
          .sort()
        if (dates.length && !row.deliveryDate) row.deliveryDate = dates[0]
        else if (dates.length && row.deliveryDate && dates[0] < row.deliveryDate) row.deliveryDate = dates[0]
        const codes = [...new Set(row.allocs.map(a => a.requisitionCode).filter(Boolean))]
        row.sourceSummary = codes.length <= 2 ? codes.join('、') : `${codes[0]} 等${codes.length}单`
        this.calcLineAmount(row)
      })
      this.displayLines = Array.from(map.values())
    },
    onSupplierChange(row, supplierId) {
      const supplierName = this.resolveSupplierName(supplierId)
      ;(row.allocs || []).forEach(alloc => {
        const src = this.sourceLines.find(s => s.requisitionLineId === alloc.requisitionLineId)
        if (src) {
          src.supplierId = supplierId || ''
          src.supplierName = supplierName
        }
      })
      this.rebuildDisplayLines()
    },
    removeDisplayLine(row) {
      const removeIds = new Set((row.allocs || []).map(a => a.requisitionLineId))
      this.sourceLines = this.sourceLines.filter(s => !removeIds.has(s.requisitionLineId))
      this.rebuildDisplayLines()
    },
    calcLineAmount(row) {
      if (row.price != null && row.quantity != null) {
        row.amount = Number((row.price * row.quantity).toFixed(2))
      }
    },
    validateDisplayLines() {
      for (let i = 0; i < this.displayLines.length; i++) {
        const line = this.displayLines[i]
        const rowNo = i + 1
        if (!line.supplierId) return `第${rowNo}行：请选择供应商`
        if (line.price == null || line.price === '') return `第${rowNo}行：含税单价不能为空`
        if (line.tax === null || line.tax === undefined || line.tax === '') return `第${rowNo}行：税点不能为空`
        if (!line.deliveryDate) return `第${rowNo}行：交货日期不能为空`
      }
      return ''
    },
    submitHandle() {
      if (!this.displayLines.length) {
        this.$message.error('请至少维护一条订单明细')
        return
      }
      const lineErr = this.validateDisplayLines()
      if (lineErr) {
        this.$message.error(lineErr)
        return
      }
      this.$refs.dataForm.validate(valid => {
        if (!valid) return
        this.submitLoading = true
        request.post('/purchase/purchaseRequisition/batchConvertToPo', {
          orderDate: this.dataForm.orderDate,
          remark: this.dataForm.remark,
          lines: this.displayLines.map(line => ({
            materialId: line.materialId,
            supplierId: line.supplierId,
            quantity: line.quantity,
            price: line.price,
            tax: line.tax,
            deliveryDate: line.deliveryDate ? String(line.deliveryDate).slice(0, 10) : null,
            allocs: (line.allocs || []).map(alloc => ({
              requisitionLineId: alloc.requisitionLineId,
              quantity: alloc.quantity
            }))
          }))
        }).then(res => {
          const list = (res.data && res.data.list) || res.data || []
          const codes = (Array.isArray(list) ? list : []).map(item => item.purchaseOrderCode).filter(Boolean)
          const msg = codes.length
            ? `已生成 ${codes.length} 张采购订单：${codes.join('、')}（开立状态，请至采购订单确认）`
            : '已生成采购订单（开立状态，请至采购订单确认）'
          this.$message.success(msg)
          this.visible = false
          this.$emit('success')
        }).catch(() => {}).finally(() => { this.submitLoading = false })
      })
    }
  }
}
</script>
